import { createBrowserHistory } from 'history';
import { authCheck } from '../utils';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from '../reducers/index';
import api from '../middleware/api';
import { BASE_NAME } from '../constants';
import persistStore from 'redux-persist/es/persistStore';

const history = createBrowserHistory({
  basename: BASE_NAME,
});

const configureStore = preloadedState =>
  createStore(
    createRootReducer(history),
    preloadedState,
    compose(
      applyMiddleware(thunk, api, routerMiddleware(history)),
      window.devToolsExtension ? window.devToolsExtension() : f => f,
    ),
  );

const auth = authCheck();
const store = configureStore(auth);
const persistor = persistStore(store);

export { history, auth, store, persistor };
